import React, { useEffect } from 'react';
import { Button, DynamicForm } from 'components';
import endpoints from 'constants/endpoints';
import { timeZones } from 'constants/timeZones';
import useApi from 'hooks/useApi';
import useFormHandler from 'hooks/useFormHandler';
import { Props } from 'types/modals';
import Base from '../../base';
import schema from './schema';
import './_styles.scss';

const CreationVenueModal = ({ closing, onClose }: Props) => {
  const formHandler = useFormHandler(schema);
  const apiStates = useApi();

  const handleSubmit = () => {
    formHandler.setIsSubmitting(true);
    const { ubication, venueName, ...restData } = formHandler.data;

    const venueAddress = {
      lineOne: ubication?.address?.lineOne || '',
      lineTwo: ubication?.address?.lineTwo || '',
      city: ubication?.address?.city || '',
      state: ubication?.address?.state || '',
      postalCode: ubication?.address?.postalCode || ''
    };

    // Ensure coordinates are properly extracted and included
    const coordinates =
      ubication?.coordinates && ubication.coordinates.lat && ubication.coordinates.lng
        ? {
            lat: parseFloat(ubication.coordinates.lat),
            lng: parseFloat(ubication.coordinates.lng)
          }
        : null;

    const dataToSend = {
      ...restData,
      name: venueName || ubication?.name || '',
      address: venueAddress,
      coordinates
    };

    onClose(dataToSend);
  };

  useEffect(() => {
    // Load timezone options immediately
    formHandler.setSchema({
      ...schema,
      timezone: {
        ...schema.timezone,
        options: [...timeZones.map((item: any) => ({ label: item, value: item }))]
      }
    });
  }, []);

  useEffect(() => {
    apiStates.fetchData(endpoints.GET_VALID_STATES.get());
  }, []);

  return (
    <Base
      header="Create venue"
      closing={closing}
      onClose={onClose}
      size="md"
      footer={<Button text="Create" disabled={!formHandler.valid || formHandler.isSubmitting} onClick={handleSubmit} />}
    >
      <div className="venue-form-wrapper">
        <div className="modal-create-venue">
          <DynamicForm handler={formHandler} />
        </div>
        {apiStates.isLoading && (
          <div className="form-loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}
      </div>
    </Base>
  );
};

export default CreationVenueModal;
